import { groupBy } from 'lodash'
import { useEffect, useState } from 'react'
import { usePageState } from '../../context/page-context'
import { useGetWellData } from '../../hooks/use-api'
import { kebabCase } from 'lodash'
import { TableOfContents } from '../../components/table-of-contents'
import { AnchorLinkProps, TableOfContentsSection } from '../../components/table-of-contents/table-of-contents-section'
import { BodyTextContainer, Button, ContentContainer, Divider, Heading, Icon, useTitleChange } from '@msaf/core-react'

interface HelpArticles {
  articleId: number
  subHeading: string
  description: string
  url: string
}

export default function HelpCentre() {
  useTitleChange('Help centre')
  const { setPageState } = usePageState()
  const [articles, setArticles] = useState<{ [key: string]: HelpArticles[] }>({})
  const url = `wells/help-centre/view`

  const { isLoading, isSuccess, data } = useGetWellData(url)

  useEffect(() => {
    if (isSuccess && data?.state.articles) {
      setArticles(groupBy(data.state.articles, 'heading'))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isSuccess, data?.state.articles])

  useEffect(() => {
    setPageState({
      heading: 'Help centre',
    })

    // Reset page state on unmount
    return () => setPageState({})
  }, [setPageState])

  return (
    <ContentContainer>
      <TableOfContents heading='Help topics' headingLevel={2}>
        {Object.keys(articles).map((heading, i) => {
          let items: AnchorLinkProps[] = []
          articles[heading].forEach((item) => {
            items.push({
              label: item.subHeading,
              anchorLink: `#${kebabCase(item.subHeading)}`,
            })
          })
          return <TableOfContentsSection key={`${heading} link`} heading={heading} headingLevel={3} items={items} />
        })}
      </TableOfContents>
      <Divider isFullWidth />
      {Object.keys(articles).map((heading, i) => {
        return (
          <div key={heading}>
            <Heading className='c-table-of-contents__heading' level={2}>
              <Icon icon='information-solid' ariaHidden /> {heading}
            </Heading>
            {articles[heading].map((item) => (
              <BodyTextContainer key={item.subHeading}>
                <div id={kebabCase(item.subHeading)}>
                  <Heading isSkeleton={isLoading} level={3}>
                    {item.subHeading}
                  </Heading>
                  <p>{item.description}</p>
                  {item.url && (
                    <Button path={item.url} target='_blank' label='View document' icon='export' iconAlignment='left' />
                  )}
                </div>
              </BodyTextContainer>
            ))}
            <Divider isFullWidth />
          </div>
        )
      })}
    </ContentContainer>
  )
}
